import React, { useState } from 'react';
import FsLightbox from 'fslightbox-react';
import { FiZoomIn } from 'react-icons/fi';
import SectionTitle from '../sectionTitle/SectionTitle';
import ProductImagesData from '../../data/products/ProductImagesData';
import './ProductImageGallery.scss';

const ProductImageGallery = ({
    subtitle = "Our Work In Pictures",
    title = "Product Image Gallery",
    description = "A closer look at the products we manufacture and deliver.",
    sectionClass = "rn-section-gap",
    items: itemsProp,
    limit,
    children
}) => {
    const source = itemsProp || ProductImagesData;
    const items = limit ? source.slice(0, limit) : source;

    const [lightbox, setLightbox] = useState({ toggler: false, slide: 1 });

    const openLightbox = (index) => {
        setLightbox((prev) => ({ toggler: !prev.toggler, slide: index + 1 }));
    };

    return (
        <div className={`rwt-product-image-gallery-area ${sectionClass}`}>
            <div className="container">
                <div className="row">
                    <div className="col-lg-12 mb--40">
                        <SectionTitle
                            textAlign="text-center"
                            radiusRounded=""
                            subtitle={subtitle}
                            title={title}
                            description={description}
                        />
                    </div>
                </div>
                <div className="row mt_dec--30 row--15">
                    {items.map((item, index) => (
                        <div
                            className="col-lg-4 col-md-6 col-sm-6 col-12 mt--30"
                            key={item.id}
                            data-aos="fade-up"
                            data-aos-delay={index * 100}
                        >
                            <div className="product-image-card">
                                <div className="product-image-card-thumb">
                                    <img src={item.image} alt={item.alt || item.title} />
                                    <div className="product-image-overlay">
                                        <button
                                            type="button"
                                            className="product-image-zoom-btn"
                                            onClick={() => openLightbox(index)}
                                            aria-label={`Zoom ${item.alt || item.title || 'image'}`}
                                        >
                                            <FiZoomIn />
                                        </button>
                                    </div>
                                </div>
                                {(item.title || item.description) && (
                                    <div className="product-image-card-content">
                                        {item.title && <h6 className="title">{item.title}</h6>}
                                        {item.description && <p className="description">{item.description}</p>}
                                    </div>
                                )}
                            </div>
                        </div>
                    ))}
                </div>
                {children}
            </div>
            <FsLightbox
                toggler={lightbox.toggler}
                sources={items.map((item) => item.image)}
                slide={lightbox.slide}
                type="image"
            />
        </div>
    );
};

export default ProductImageGallery;
